module.exports = __webpack_public_path__ + "media/images/icon04-7bf8b7fe7a3c0b561c363902979db3cf.png";